/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue"
import axios from "../../http/axios/index.js"

export default {
  SET_WORKBOOK_LIST(state, list) {
    state.workbookList = list
  },
  SET_WORKBOOK_TYPE_LIST(state, list) {
    state.workbookTypeList = list
  },
  SET_SELECTED_WORKBOOK(state, workbook) {
    state.selectedWorkbook = workbook
  },
  ADD_WORKBOOK(state, newBook) {
    state.workbookList.unshift(newBook)
  },
  UPDATE_WORKBOOK(state, updatedBook) {
    const idx = state.workbookList.findIndex(b => b.id === updatedBook.id)
    if (idx !== -1) state.workbookList.splice(idx, 1, updatedBook)
  }
}
